import React, { useEffect, useState } from 'react';
import Aux from '../../hoc/Aux';
import * as actions from '../../store/actions/index';
import { useParams } from "react-router";
import { useDispatch } from 'react-redux'
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const registerVerification = (props) => {

  const { token } = useParams();
  const dispatch = useDispatch();
  const ct = useCustomTranslation();
  const [verified, setVerified] = useState(undefined);

  useEffect(() => {
    dispatch( actions.registerVerification(token) ).then( (res) => setVerified(res) )
  }, []);

  return (
    <Aux>
      <div className="main-container">
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-lg-11 col-xl-10">
                  <div className="page-header">
                     <h1>{ ct('sign_up_verification.headline') }</h1>
                       <div className="card " style={{marginTop: "20px", border: "none"}}>

                         {
                           (verified === true)?
                             <Aux>
                               <div className="card-body">
                                 <p className="lead" >{ ct('sign_up_verification.success.text') }</p>
                               </div>
                               <div className="row justify-content-end">
                                 <Link className="btn btn-primary btn-project" to={ROUTES.TO_LOGIN} style={{marginTop: "10px"}}>{ ct('sign_up_verification.success.link_to_sign_in') }</Link>
                               </div>
                             </Aux>
                             : null
                         }
                         {
                           (verified === false)?
                           <Aux>
                             <div className="card-body">
                               <p className="lead" >{ ct('sign_up_verification.error.text') }</p>
                             </div>
                           </Aux>
                             : null
                         }

                       </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    </Aux>
  )
};

export default registerVerification;



// WEBPACK FOOTER //
// ./src/components/Auth/RegisterVerification.js